import _ from "lodash";

import { PIDeviceToDeviceType, PIDeviceTypes } from "@tether-web-portal/types/PropertyInfo";
import { DeviceType } from "@tether-web-portal/types/DeviceType";
import { DeviceTypeLabel } from "@tether-web-portal/types/DeviceTypeLabel";
import { getDeviceCapability } from "@tether-web-portal/api/catalog/deviceCatalogCache";

export const formatDeviceName = (input: string | DeviceType | PIDeviceTypes): string => {
  if (!input) return "";

  // Prefer the device-type catalog display name. The input may be a PI device-type alias, so resolve
  // that to its DeviceType first. Falls back to the static label / humanised string when the type is
  // not in the catalog (or the catalog has not loaded yet).
  const deviceType = PIDeviceToDeviceType[input as PIDeviceTypes] ?? input;
  const capability = getDeviceCapability(deviceType.toString());
  if (capability) return capability.displayName;

  const deviceTypeTest = DeviceTypeLabel[input as DeviceType];
  if (deviceTypeTest) return deviceTypeTest;

  const PIDeviceTypeTest = PIDeviceToDeviceType[input as PIDeviceTypes];
  if (PIDeviceTypeTest) return DeviceTypeLabel[PIDeviceTypeTest];

  return _.upperFirst(_.lowerCase(input.toString()));
};
